"use client";
import { jsx } from "react/jsx-runtime";
import { Box } from "@mantine/core";
import { createRef, useEffect } from "react";
import { v4 } from "uuid";
import { useTracking } from "./useTracking.js";
const useUniqueDefs = () => {
  const localRef = createRef();
  useEffect(() => {
    if (localRef.current) {
      if (localRef.current.getElementsByTagName("defs").length <= 0) {
        return;
      }
      const defs = localRef.current.getElementsByTagName("defs")[0].children;
      const masks = localRef.current.getElementsByTagName("mask");
      for (let i = 0; i < defs.length; i += 1) {
        const elements = localRef.current.querySelectorAll(`[fill='url(#${defs[i].id})']`);
        const uses = localRef.current.querySelectorAll(`use`);
        const uniqueId = v4();
        elements.forEach((element) => {
          element.setAttribute("fill", `url(#${uniqueId})`);
        });
        uses.forEach((use) => {
          if (use.getAttribute("xlink:href") === `#${defs[i].id}`) {
            use.setAttribute("xlink:href", `#${uniqueId}`);
          }
        });
        defs[i].id = uniqueId;
      }
      for (let i = 0; i < masks.length; i += 1) {
        const uniqueId = v4();
        const groups = localRef.current.querySelectorAll(`g[mask='url(#${masks[i].id})']`);
        masks[i].id = uniqueId;
        groups.forEach((group) => {
          group.setAttribute("mask", `url(#${uniqueId})`);
        });
      }
    }
  }, []);
  return { ref: localRef };
};
const useSvg = (name, list, size, stroke) => {
  var _a;
  const tracker = useTracking();
  const { ref: uniqueDefsRef } = useUniqueDefs();
  let Svg = list[name];
  if (Svg === void 0) {
    (_a = tracker == null ? void 0 : tracker.monitor) == null ? void 0 : _a.exception({
      message: "Could not find matching Figure",
      severityLevel: 3,
      properties: { missingFigureName: name }
    });
    const firstItemName = Object.keys(list)[0];
    Svg = list[firstItemName];
  }
  return /* @__PURE__ */ jsx(
    Box,
    {
      component: Svg,
      w: "100%",
      h: "100%",
      ref: uniqueDefsRef,
      size,
      stroke: stroke == null ? void 0 : stroke.toString()
    }
  );
};
export {
  useSvg,
  useUniqueDefs
};
